const IMAGE_URL = process.env.REACT_APP_API_IMAGE_URL as string;
const DEV_DOMAIN = process.env.REACT_APP_DEV_DOMAIN as string;

export const BASE_URL = process.env.REACT_APP_API_BASE_URL as string;
export const STORE_KEY = process.env.REACT_APP_API_STORE_KEY as string;
export const SITE_DOMAIN = process.env.REACT_APP_SITE_DOMAIN as string;
export const SOCKET_URL = process.env.REACT_APP_API_SOCKET_URL as string;

export const SPORT_IMAGE_URL = process.env.REACT_APP_API_SPORT_IMAGE_URL as string;

// Test builds: event pages ask for every market so settlement can be tried (needs Betaxis SPORTS_TEST_MODE).
export const SPORT_TEST_MODE = process.env.REACT_APP_SPORT_TEST_MODE === "true";

export const getClientDomain = (): string => {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  // Never empty: an unset REACT_APP_DEV_DOMAIN would otherwise drop the
  // `x-domain` header altogether, and the API refuses every auth call without it.
  return host === "localhost" || host === "127.0.0.1" ? DEV_DOMAIN || SITE_DOMAIN || host : host;
};

// What image-server can shrink; SVG, GIF and other hosts' files are left as they are.
const RESIZABLE = /\.(png|jpe?g|webp|avif)$/i;

/**
 * `width` is the largest CSS width the image is shown at. Our image-server then sends a WebP
 * twice that wide (sharp on high-DPI screens) instead of the full upload, often ~2 MB.
 */
export const getMediaUrl = (value?: string, width?: number): string => {
  if (!value) return "";
  let url: string;
  if (/^https?:\/\//i.test(value) || value.startsWith("/") || value.startsWith("data:")) {
    url = value;
  } else {
    if (!IMAGE_URL) return "";
    url = `${IMAGE_URL}/${value}`;
  }
  if (!width || !IMAGE_URL || !url.startsWith(`${IMAGE_URL}/`) || !RESIZABLE.test(url)) return url;
  return `${url}?w=${Math.ceil(width * 2)}`;
};

// Steps of image-server's width ladder, so every candidate is a variant it already keeps.
const SRCSET_WIDTHS = [384, 768, 1280, 1920];

/** A `srcSet` for an image-server upload, so a phone takes a phone-sized copy; undefined for anything else. */
export const getMediaSrcSet = (value?: string): string | undefined => {
  const url = getMediaUrl(value);
  if (!url || !IMAGE_URL || !url.startsWith(`${IMAGE_URL}/`) || !RESIZABLE.test(url))
    return undefined;
  return SRCSET_WIDTHS.map((width) => `${url}?w=${width} ${width}w`).join(", ");
};

export * from "./endpoints";
export * from "./routers";
